import '@mdi/font/css/materialdesignicons.css'
import 'font-awesome/css/font-awesome.min.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import {
  VRow,
  VCol,
  VCard,
  VCardTitle,
  VCardText,
  VCardActions,
  VCardSubtitle,
  VCardItem,
  VIcon,
  VForm,
  VImg,
  VSpacer,
  VSkeletonLoader,
  VDivider,
  VVirtualScroll,
  VSheet,
  VSnackbar,
  VTooltip,
  VPagination
} from 'vuetify/components'
import { ClickOutside, Resize } from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import '@/styles/global.scss'

const appTheme = {
  dark: false,
  colors: {
    blue_50: '#EFF6FF',
    blue_200: '#BFDBFE',
    blue_500: '#3B82F6',
    blue_600: '#2563EB',
    black_10: '#E8E8E8',
    blue_700: '#1D4ED8',
    brand: '#005FFF',
    brand_dark: '#104B4A',
    danger_200: '#efd1c5',
    danger_300: '#FFCCD2',
    danger_700: '#EC2D30',
    emerald_50: '#ECFDF5',
    emerald_700: '#047857',
    gray: '#C5C2C0',
    gray_400: '#9CA3AF',
    gray_900: '#111827',
    gray_700: '#7b7b7b',
    off_white: '#EEF5F5',
    orange_500: '#F97316',
    orange_600: '#EA580C',
    pink_50: '#FDF2F8',
    pink_600: '#DB2777',
    slate_50: '#F8FAFC',
    slate_100: '#F1F5F9',
    slate_300: '#CBD5E1',
    slate_400: '#94A3B8',
    slate_500: '#64748B',
    slate_600: '#475569',
    slate_700: '#334155',
    slate_900: '#0F172A',
    success_700: '#4CAF50',
    negative_700: '#D50000',
    warning_700: '#FFFF8D',
    white: '#FFFFFF',
    emerald_600: '#059669',
    emerald_100: '#D1FAE5',
    gray_100: '#F3F4F6',
    blue_900: '#1E3A8A',
    blue_100: '#DBEAFE',
    orange_900: '#7C2D12',
    orange_100: '#FFEDD5',
    label_500: '#666666',
    hover_theme: '#E7F4F1',
    yellow_900: '#ffe000',
    yellow_200: '#fff5be',
    
  }
}

export default createVuetify({
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi
    }
  },
  components: {
    VRow,
    VCol,
    VCard,
    VCardTitle,
    VCardText,
    VCardActions,
    VCardSubtitle,
    VCardItem,
    VIcon,
    VForm,
    VImg,
    VSpacer,
    VSkeletonLoader,
    VDivider,
    VVirtualScroll,
    VSheet,
    VSnackbar,
    VTooltip,
    VPagination
  },
  directives: { ClickOutside, Resize },
  theme: {
    defaultTheme: 'appTheme',
    themes: {
      appTheme
    }
  },
  defaults: {
    VChip: {
      closeIcon: 'mdi-close'
    }
  }
})
